import React from "react";
import { withRouter } from "react-router-dom";

class LandlordCharges extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data || {},
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  render() {
    const { data } = this.state;

    if (!data || Object.keys(data).length === 0) {
      return <h1 className="landLordDetailHeading text-center mt-4">No Record Available</h1>;
    }

    return (
      <div>
        {Object.keys(data).map((category) => (
          <div key={category}>
            <h2 className="landLordDetailHeading">{category.toUpperCase()}</h2>
            <table className="table tableSimple" border="1" style={{ width: "100%", marginBottom: "20px" }}>
              <thead>
                <tr>
                  <th>Landlord Name</th>
                  <th>Percentage(%)</th>
                </tr>
              </thead>
              <tbody>
                {data[category].map((item, index) => (
                  <tr key={index}>
                    <td>{item.landlord_name}</td>
                    <td>{item.percentage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(LandlordCharges);
